import { StoryDataProvider, useStoryDataContext } from "contexts/StoryContext";
import { People } from "../People/people";
import { StoriesDataProvider } from "../../contexts/StoriesContext";

const StoryPage = () => {
  const {story} = useStoryDataContext();

  return (
    <StoriesDataProvider creator={story?.creator}>
      <People />
    </StoriesDataProvider>
  );
};

const StoryPageWrapper = () => {
  return (
    <StoryDataProvider>
      <StoryPage />
    </StoryDataProvider>
  );
};

export default StoryPageWrapper;
